
import React from 'react';
import { WidgetBaseProps } from './WidgetTypes';
import FeatureErrorBoundary from '@/components/FeatureErrorBoundary';
import RecommendedArticlesWidget from '@/components/recommended-articles/RecommendedArticlesWidget';

const RecommendedWidget: React.FC<WidgetBaseProps> = ({
  crawlResult,
  widgetRef,
  onRetry
}) => {
  return (
    <div ref={widgetRef} className="pt-8" id="recommended" data-testid="widget-recommended">
      <FeatureErrorBoundary 
        componentName="Recommended Articles Widget" 
        onRetry={onRetry}
      >
        <RecommendedArticlesWidget 
          result={crawlResult}
          onRetry={onRetry}
        />
      </FeatureErrorBoundary>
    </div>
  );
};

export default RecommendedWidget;
